import React from 'react'

import { Partners as NewPartners } from 'components'
import { Separator } from 'shared/components'
import { Wrapper } from './Wrapper'
import { Cooperation, CooperationForm, Partners, Requirements } from './blocks'

import classes from './Production.module.scss'

export const Production = (): JSX.Element => {
  return (
    <>
      {/* для seo */}
      <h1 className="hidden">Партнерство в производстве</h1>

      <Wrapper>
        <Partners />
        <Cooperation />
        <Requirements />
      </Wrapper>
      <Separator className={classes.faq_separator} />
      <CooperationForm />
      <Separator className={classes.cooperation_separator} />
      <NewPartners />
      <Separator height={80} />
    </>
  )
}
